// Module
var code = "<script>let $ctrl</script> <div class=\"atom-text-box\" ng-class=\"{ 'atom-text-box--grey' : $ctrl.color === 'grey' }\"> <atom-text modifier=\"{{ $ctrl.modifier }}\"> <ng-transclude></ng-transclude> </atom-text> </div> ";
// Exports
module.exports = code;